// lib/utils.ts

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}



export function getCountryCode(currencyCode: string): string {
  const map: Record<string, string> = {
    USD: 'US',
    EUR: 'EU',
    RUB: 'RU',
    KZT: 'KZ',
    CNY: 'CN',
    GBP: 'GB',
    JPY: 'JP',
    AUD: 'AU',
    CAD: 'CA',
    CHF: 'CH',
    SEK: 'SE',
    NOK: 'NO',
    DKK: 'DK',
    BYN: 'BY',
    UAH: 'UA',
    AZN: 'AZ',
    AMD: 'AM',
    BGN: 'BG',
    CZK: 'CZ',
    HUF: 'HU',
    INR: 'IN',
    KGS: 'KG',
    MDL: 'MD',
    PLN: 'PL',
    RON: 'RO',
    SGD: 'SG',
    TJS: 'TJ',
    TMT: 'TM',
    UZS: 'UZ',
    ZAR: 'ZA',
    DZD: 'DZ',
    BHD: 'BH',
    BOB: 'BO',
    BRL: 'BR',
    VND: 'VN',
    HKD: 'HK',
    GEL: 'GE',
    AED: 'AE',
    EGP: 'EG',
    IDR: 'ID',
    IRR: 'IR',
    QAR: 'QA',
    CUP: 'CU',
    MNT: 'MN',
    NGN: 'NG',
    NZD: 'NZ',
    OMR: 'OM',
    SAR: 'SA',
    THB: 'TH',
    BDT: 'BD',
    TRY: 'TR',
    ETB: 'ET',
    RSD: 'RS',
    KRW: 'KR',
    MMK: 'MM',
  };
  return map[currencyCode] || 'UN';
}

/**
 * Возвращает название месяца в нужном падеже.
 * @param monthIndex Индекс месяца (0-11).
 * @param form Форма падежа: 'nominative' (именительный, по умолчанию), 'prepositional' (предложный, "в январе").
 * @returns Название месяца в указанном падеже.
 */
export function getDeclinedMonthName(monthIndex: number, form: 'nominative' | 'prepositional' = 'nominative'): string {
  const date = new Date(2000, monthIndex, 1); // Используем 2000 год, чтобы избежать проблем с високосным годом

  if (form === 'nominative') {
    return format(date, 'LLLL', { locale: ru }); // Январь, Февраль
  } else if (form === 'prepositional') {
    // Для предложного падежа (в январе, в феврале)
    // date-fns не имеет встроенной поддержки падежей, поэтому используем маппинг
    const monthNamesPrepositional: { [key: number]: string } = {
      0: 'январе',   // Январь -> в январе
      1: 'феврале',  // Февраль -> в феврале
      2: 'марте',    // Март -> в марте
      3: 'апреле',   // Апрель -> в апреле
      4: 'мае',      // Май -> в мае
      5: 'июне',     // Июнь -> в июне
      6: 'июле',     // Июль -> в июле
      7: 'августе',  // Август -> в августе
      8: 'сентябре', // Сентябрь -> в сентябре
      9: 'октябре',  // Октябрь -> в октябре
      10: 'ноябре',   // Ноябрь -> в ноябре
      11: 'декабре',  // Декабрь -> в декабре
    };
    return monthNamesPrepositional[monthIndex] || format(date, 'LLLL', { locale: ru }); // Fallback
  }
  return format(date, 'LLLL', { locale: ru }); // По умолчанию именительный
}
